module.exports = __webpack_public_path__ + "static/media/PERA.61d38b98.png";